import { Image, Layout } from "antd";
import React, { useEffect, useState } from "react";
import {
  FaArrowRight,
  FaBookOpen,
  FaCertificate,
  FaClock,
  FaComments,
  FaEnvelope,
  FaGlobe,
  FaGraduationCap,
  FaLightbulb,
  FaShieldAlt,
  FaUserFriends,
  FaUsers,
} from "react-icons/fa";
import { BsFillTelephoneFill } from "react-icons/bs";
import { HiOutlineDesktopComputer } from "react-icons/hi";
import { IoMdPin } from "react-icons/io";
import { MdOutlineSupportAgent } from "react-icons/md";
import { TiArrowSortedDown } from "react-icons/ti";
import { useNavigate } from "react-router";
import { ImageUrl } from "../../helpers/Functions";
import "../course-management/course-management.css";
import "./faq.css";

const faqs = [
  {
    index: 1,
    text: "What types of training programs do you offer? ",
    innerText:
      "We offer a range of online training programs for the early care and education industry, including foundational courses, specialized skill development, and professional development opportunities. Our training covers topics supporting every service area. Courses cover everything from board development to early childhood development, classroom management, early literacy, facilities, health and safety, and more.",
    Icon: FaGraduationCap,
  },
  {
    index: 2,
    text: "How do I enroll in a course?",
    innerText:
      "Student registration is free and easy! On the home page, click the Join Us Free button and follow the instructions to register. You must create an account to track your progress and access course materials.",
    Icon: FaBookOpen,
  },
  {
    index: 3,
    text: "Can I take the courses at my own pace?",
    innerText:
      "Yes, most of our online training programs are self-paced. You can start and finish the courses according to your schedule or as your organization outlines, allowing you to balance your professional responsibilities with your learning.",
    Icon: FaClock,
  },
  {
    index: 4,
    text: "Will I receive a certificate after completing a course?",
    innerText:
      "Yes, upon completing a course, you will receive a certificate of completion that you can use for professional development or to meet licensing requirements (where applicable).",
    Icon: FaCertificate,
  },
  {
    index: 5,
    text: "What technology do I need to participate in online training?",
    innerText:
      "Our courses are compatible with most devices, including desktops, laptops, tablets, and smartphones. You only need an internet connection and a modern web browser (Chrome, Firefox, Safari, etc.) to access the training materials. If it's an in-person virtual training, no worries; we can work with any of the meeting platforms, including but not limited to Zoom, Webex, Microsoft Teams, or Google Meet.",
    Icon: HiOutlineDesktopComputer,
  },
  {
    index: 6,
    text: "Are your courses available in languages other than English?",
    innerText:
      "Currently, most of our courses are offered in English. Some translation features are built-in, and we are working on expanding our offerings. We hope to provide multilingual training options shortly. Please check the individual course descriptions for language availability.",
    Icon: FaGlobe,
  },
  {
    index: 7,
    text: "Are the training programs accredited? ",
    innerText:
      "No, not at this time. However, we are working on accredited courses that will fulfill continuing education requirements. Please check the course details or contact us for more information on specific accreditation or certification.",
    Icon: FaShieldAlt,
  },
  {
    index: 8,
    text: "Can I get a refund if I’m unsatisfied with a course I've taken? ",
    innerText:
      "We offer a satisfaction guarantee for our training programs. If you're unsatisfied with a course, please get in touch with us within a specified time frame (typically within 14 days of purchase) for a refund or course credit. Please take a look at our refund policy for more details.",
    Icon: MdOutlineSupportAgent,
  },
  {
    index: 9,
    text: "How can I contact customer support if I have questions or issues?",
    innerText:
      "You can reach our customer support team by email at [support@wrightcoacademy.com] or by calling 877-701-2899. Our team can assist you with any enrollment, technical, or course-related questions.",
    Icon: FaComments,
  },
  {
    index: 10,
    text: "Do you offer group or organizational training packages? ",
    innerText:
      "Yes! We offer customized group training solutions for organizations, and we have enterprise options. If you're interested in training for a team or organization, please get in touch with us to discuss your needs and get a quote. Call us at 877-701-2899.",
    Icon: FaUsers,
  },
  {
    index: 11,
    text: "How are your training programs delivered? ",
    innerText:
      "In addition to offering virtual and on-demand training, we offer in-person training  (at a location of your choice). We can also offer a customized hybrid model combining any two of the former. For in-person training, you can reach our customer training support team by email at training@wrightcoacademy.com or by calling us at 877-701-2899.",
    Icon: FaUserFriends,
  },
];

const FAQ = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout className="cm-page faq-page">
      <section
        className="cm-hero"
        style={{
          backgroundImage: `url(${ImageUrl("faq-bnr.png")})`,
        }}
      >
        <div className="cm-hero-overlay" aria-hidden />
        <div className="cm-wrap cm-hero-inner">
          <div className="cm-hero-copy">
            <span className="cm-hero-badge">SUPPORT CENTER</span>
            <h1 className="fontFamily1 cm-hero-title">FAQ</h1>
            <p className="fontFamily1 cm-hero-sub">
              Quick answers to the most common questions about training,
              enrollment, certifications, and support.
            </p>
          </div>
        </div>
      </section>

      <div className="cm-wrap cm-main faq-main">
        <div className="faq-content-shell">
          <div className="faq-list-col">
            <Rows />
          </div>

          <aside className="faq-sidebar">
            <h2 className="fontFamily1 faq-sidebar-title">
              Still Have <span>Questions?</span>
            </h2>

            <div className="faq-sidebar-image-wrap">
              <Image
                alt="FAQ illustration"
                preview={false}
                src={ImageUrl("faq.png")}
                className="faq-sidebar-image"
              />
            </div>

            <ul className="faq-sidebar-list">
              <li className="faq-sidebar-item">
                <span className="faq-sidebar-icon" aria-hidden>
                  <IoMdPin />
                </span>
                <p className="faq-sidebar-value">
                  1000 Front Street #147 Uniondale, NY 11553
                </p>
              </li>
              <li className="faq-sidebar-item">
                <span className="faq-sidebar-icon" aria-hidden>
                  <FaEnvelope />
                </span>
                <p className="faq-sidebar-value">info@support.com</p>
              </li>
              <li className="faq-sidebar-item">
                <span className="faq-sidebar-icon" aria-hidden>
                  <BsFillTelephoneFill />
                </span>
                <p className="faq-sidebar-value">+03601 885399</p>
              </li>
              <li className="faq-sidebar-item">
                <span className="faq-sidebar-icon" aria-hidden>
                  <FaClock />
                </span>
                <p className="faq-sidebar-value">
                  Mon - Fri: 9:00 AM - 6:00 PM
                  <br />
                  Saturday - Sunday: Closed
                </p>
              </li>
            </ul>

            <button
              type="button"
              className="faq-sidebar-cta"
              onClick={() => navigate("/contact-us")}
            >
              Contact Support
              <FaArrowRight aria-hidden />
            </button>
          </aside>
        </div>

        <div className="faq-features">
          <div className="faq-feature">
            <span className="faq-feature-icon faq-feature-icon--blue" aria-hidden>
              <FaLightbulb />
            </span>
            <div>
              <h3>Expert Support</h3>
              <p>Get answers from our knowledgeable team.</p>
            </div>
          </div>
          <div className="faq-feature">
            <span className="faq-feature-icon faq-feature-icon--teal" aria-hidden>
              <FaShieldAlt />
            </span>
            <div>
              <h3>Trusted Guidance</h3>
              <p>Reliable information to help you succeed.</p>
            </div>
          </div>
          <div className="faq-feature">
            <span className="faq-feature-icon faq-feature-icon--orange" aria-hidden>
              <FaUserFriends />
            </span>
            <div>
              <h3>Learner Focused</h3>
              <p>We&apos;re dedicated to your learning journey.</p>
            </div>
          </div>
          <div className="faq-feature">
            <span className="faq-feature-icon faq-feature-icon--purple" aria-hidden>
              <FaComments />
            </span>
            <div>
              <h3>Quick Response</h3>
              <p>We respond as fast as we can.</p>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default FAQ;

const Rows = () => {
  const CustomRow = ({ faq }) => {
    const [expanded, setExpanded] = useState(false);
    const Icon = faq.Icon || FaGraduationCap;

    const toggleExpand = () => {
      setExpanded(!expanded);
    };

    return (
      <div className={`faq-item${expanded ? " faq-item--open" : ""}`}>
        <button
          type="button"
          onClick={toggleExpand}
          className="faq-item-header"
          aria-expanded={expanded}
        >
          <span className="faq-item-leading" aria-hidden>
            <Icon />
          </span>
          <h4 className="faq-item-title">{faq.text}</h4>
          <span className="faq-item-icon-wrap">
            <TiArrowSortedDown
              className={`faq-item-icon${expanded ? " rotate-180" : ""}`}
            />
          </span>
        </button>

        <div
          style={{
            maxHeight: expanded ? "500px" : "0px",
            opacity: expanded ? 1 : 0,
            paddingTop: expanded ? "4px" : "0px",
            paddingBottom: expanded ? "16px" : "0px",
          }}
          className="faq-item-content"
        >
          <p className="faq-item-text">{faq.innerText}</p>
        </div>
      </div>
    );
  };

  return (
    <div className="faq-accordion-list">
      {faqs?.map((faq, index) => (
        <CustomRow key={faq.index || index} faq={faq} />
      ))}
    </div>
  );
};
